// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tab-filter_tabs__vWrBC","tabItem":"tab-filter_tabItem__ekXSP","tabItemActive":"tab-filter_tabItemActive__VGTXj","dropdown":"tab-filter_dropdown__e4LOk"};